/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid Flexibility`)
};

const zh_hans1_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合验证支持`)
};

const zh_hant1_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合驗證支援`)
};

const fr_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexibilité hybride`)
};

const de_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybride Flexibilität`)
};

const ja_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイブリッドな柔軟性`)
};

const ko_card_multi_auth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하이브리드 유연성`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_multi_auth_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_multi_auth_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_multi_auth_title", locale)
	if (locale === "en") return en_card_multi_auth_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_multi_auth_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_multi_auth_title(inputs)
	if (locale === "fr") return fr_card_multi_auth_title(inputs)
	if (locale === "de") return de_card_multi_auth_title(inputs)
	if (locale === "ja") return ja_card_multi_auth_title(inputs)
	return ko_card_multi_auth_title(inputs)
};